import { Injectable } from '@angular/core';

import DomainEventProvider from '../../../../../core/domain/events/domain_event_provider';
import { CustomNutritionEvent } from './custom_nutrition_events';

@Injectable({ providedIn: 'root' })
export class CustomNutritionEventProvider extends DomainEventProvider<CustomNutritionEvent> {}
